import { Controller } from "@hotwired/stimulus";
import 'select2';
import 'select2/dist/css/select2';

const DAY_ABBREVIATIONS = ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'];

export default class extends Controller {
  static targets = [
    'scheduleModalMask',
    'scheduleAttendanceForm',
    'scheduleAttributes',
    'scheduleProfessor',
    'modalCard',
    'timeInputsSection',
    'batchInfoSection',
    'batchTimeDisplay',
    'professorSection'
  ];

  // ── Abre modal no modo individual (botão flutuante) ──────────────────────────

  openModal() {
    const activeDayTab = this.element.querySelector('[data-weekly-calendar-target="dayTab"].active-day');
    const selectedDate = activeDayTab?.dataset?.date || this._currentWeekDate();

    this._restoreOriginalFormAction();
    this._switchToIndividualMode();
    this._prefillModalDate(selectedDate);
    this._clearTimeFields();
    this._initializeProfessorSelect();
    this.scheduleModalMaskTarget.classList.remove('hidden');
  }

  // ── Abre modal no modo batch (clique num card de turma) ──────────────────────

  openModalFromBatchSchedule(event) {
    const card        = event.currentTarget;
    const formAction  = card.dataset.formAction;
    const startTime   = card.dataset.startTime;
    const endTime     = card.dataset.endTime;
    const dayListDiv  = card.closest('[data-weekly-calendar-target="dayList"]');
    const selectedDate = dayListDiv?.dataset?.date || this._currentWeekDate();

    this._switchToBatchMode(startTime, endTime);
    this._prefillModalDate(selectedDate);
    this.scheduleAttendanceFormTarget.setAttribute('action', formAction);
    this.scheduleModalMaskTarget.classList.remove('hidden');
  }

  // ── Fecha modal ──────────────────────────────────────────────────────────────

  closeScheduleModal() {
    this._hideModal();
  }

  // ── Submete o formulário ─────────────────────────────────────────────────────

  scheduleAttendance() {
    if (this._isBatchMode) {
      this.scheduleAttendanceFormTarget.submit();
      return;
    }

    const selectedDate = this.scheduleAttributesTarget.querySelector('input[name="date"]').value;
    const startTime    = this.scheduleAttributesTarget.querySelector('input[name="start_time"]').value.trim();
    const endTime      = this.scheduleAttributesTarget.querySelector('input[name="end_time"]').value.trim();

    if (!selectedDate || !startTime || !endTime) {
      this._markEmptyFields({ startTime, endTime });
      return;
    }

    const formActionWithDate = this.scheduleAttendanceFormTarget
      .getAttribute('action')
      .replaceAll('required-date', selectedDate);

    this.scheduleAttendanceFormTarget.setAttribute('action', formActionWithDate);
    this.scheduleAttendanceFormTarget.submit();
  }

  // ── Privado ──────────────────────────────────────────────────────────────────

  _switchToBatchMode(startTime, endTime) {
    this._isBatchMode = true;

    if (this.hasBatchInfoSectionTarget)  this.batchInfoSectionTarget.classList.remove('hidden');
    if (this.hasTimeInputsSectionTarget) this.timeInputsSectionTarget.classList.add('hidden');
    if (this.hasProfessorSectionTarget)  this.professorSectionTarget.classList.add('hidden');

    if (this.hasBatchTimeDisplayTarget)  this.batchTimeDisplayTarget.textContent = `${startTime} às ${endTime}`;
  }

  _switchToIndividualMode() {
    this._isBatchMode = false;

    if (this.hasBatchInfoSectionTarget)  this.batchInfoSectionTarget.classList.add('hidden');
    if (this.hasTimeInputsSectionTarget) this.timeInputsSectionTarget.classList.remove('hidden');
    if (this.hasProfessorSectionTarget)  this.professorSectionTarget.classList.remove('hidden');
  }

  _restoreOriginalFormAction() {
    const originalAction = this.scheduleAttendanceFormTarget.dataset.originalAction;
    if (originalAction) this.scheduleAttendanceFormTarget.setAttribute('action', originalAction);
  }

  _prefillModalDate(selectedDate) {
    this.scheduleAttributesTarget.querySelector('input[name="date"]').value = selectedDate;

    const [year, month, day] = selectedDate.split('-').map(Number);
    const parsedDate = new Date(year, month - 1, day);
    this.scheduleAttributesTarget.querySelector('.week-day-name').textContent =
      DAY_ABBREVIATIONS[parsedDate.getDay()];
  }

  _clearTimeFields() {
    ['start_time', 'end_time'].forEach((fieldName) => {
      const input = this.scheduleAttributesTarget.querySelector(`input[name="${fieldName}"]`);
      input.value = '';
      input.classList.remove('border-red-400');
      input.addEventListener('input', () => input.classList.remove('border-red-400'), { once: true });
    });
  }

  _markEmptyFields({ startTime, endTime }) {
    const startInput = this.scheduleAttributesTarget.querySelector('input[name="start_time"]');
    const endInput   = this.scheduleAttributesTarget.querySelector('input[name="end_time"]');

    startInput.classList.toggle('border-red-400', !startTime);
    endInput.classList.toggle('border-red-400',   !endTime);

    const firstInvalid = !startTime ? startInput : endInput;
    firstInvalid.focus();
  }

  _initializeProfessorSelect() {
    const professorSelect = this.hasModalCardTarget
      ? this.modalCardTarget.querySelector('.select2-professor')
      : null;

    if (!professorSelect) return;

    $(professorSelect).select2({
      placeholder: '-- selecione o professor --',
      allowClear: false,
      width: '100%',
      dropdownParent: $(this.modalCardTarget)
    });
  }

  _hideModal() {
    this.scheduleModalMaskTarget.classList.add('hidden');
  }

  _currentWeekDate() {
    const weekDateInput = this.element.querySelector('[data-weekly-calendar-target="inputDate"]');
    return weekDateInput ? weekDateInput.value : '';
  }
}
